import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const EditOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease-in-out;

  svg {
    height: 30%;
    path {
      fill: #fff;
    }
  }
  span {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }
`;

export const Reward = styled.div<{ previewState?: boolean; hidePointer?: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 20% 51% 4% 25%;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
  aspect-ratio: 1 / 1.3;
  cursor: ${(props) => (props.hidePointer ? '' : 'pointer')};
  box-shadow: 0 0 6px 4px rgba(39, 121, 130, ${(props) => (props.previewState ? 0.4 : 0)});

  &:hover ${EditOverlay} {
    opacity: 1;
  }
`;

export const RewardStats = styled.div`
  display: flex;
  padding: 0 10px;
  

  span {
    display: flex;
    align-items: center;
    font-size: 14px;
    
  }

  span:nth-of-type(1) {
    color: #feb445;
    font-weight: 600;

    
  }

  span:nth-of-type(2) {
    margin-left: auto;
    color: rgba(${(props) => props.theme.colors.blue_rgb}, 1);
  }

  svg {
    height: 40%;
    margin-left: 4px;
  }

  ${mq(Devices.tablet)} {
    span {
      font-size: 2.5vw;
    }
  }

  ${mq(Devices.mobile)} {
    span {
      font-size: 3.8vw;
    }
  }
`;

export const RewardIcon = styled.div<{ progress?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.progress ? '1' : '0.6')};
  svg {
    height: 100%;
  }
`;

export const RewardProgress = styled.div`
  background: rgba(${(props) => props.theme.colors.blue_rgb}, 0.2);
`;

export const ProgressBar = styled.div<{ progress?: number }>`
  background: rgba(${(props) => props.theme.colors.blue_rgb}, 1);
  height: 100%;
  width: ${(props) => (props.progress ? props.progress + '%' : null)};
`;

export const RewardName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  p {
    font-size: 16px;
    line-height: 0.9vw;
    font-weight: 400;
  }

  ${mq(Devices.tablet)} {
    p {
      font-size: 2.2vw;
      line-height: 2vw;
    }
  }

  ${mq(Devices.mobile)} {
    p {
      font-size: 3.5vw;
      line-height: 3.2vw;
    }
  }
`;
